import { render, staticRenderFns } from "./IconTypeformUrlRedirect.vue?vue&type=template&id=aa49e0b6&"
import script from "./IconTypeformUrlRedirect.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformUrlRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports